import React from 'react';
import { PictureAsPdf } from '@mui/icons-material';

import { ReactComponent as ImageIcon } from '../../../../assets/icons/v2/picture.svg';
import { ReactComponent as VideoIcon } from '../../../../assets/icons/video-logo.svg';
import { ReactComponent as FileIcon } from '../../../../assets/icons/v2/notes.svg';
import { FileType } from '../../../../chat/utils/files';
import texts from './texts.json';

const TYPE_ICON = {
  [FileType.IMAGE]: <ImageIcon />,
  [FileType.VIDEO]: <VideoIcon />,
  [FileType.PDF]: <PictureAsPdf />,
  [FileType.FILE]: <FileIcon />,
};

const getTypeLabel = (type = '') => {
  if (type === FileType.IMAGE) return texts.typeImage;
  if (type === FileType.VIDEO) return texts.typeVideo;
  if (type === FileType.PDF) return texts.typePdf;
  return texts.typeFile;
};

export { TYPE_ICON, getTypeLabel };
